<div class="tw-animate-pulse {{ rounded }} {{ color }} {{ size }}"></div>
